import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../styles/auth/Login.css';
import { useAuth } from '../../hooks/useAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { GoogleLogin } from '@react-oauth/google';
import { GoogleOAuthProvider } from '@react-oauth/google';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { login } = useAuth();
    const { t } = useTranslation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
    
        const result = await login({ email, password });

        if (result === true) {
            navigate('/profile/mailbox', { replace: true });
        } else if (result?.redirectTo) {
            navigate(result.redirectTo, { replace: true });
        } else if (result?.error) {
            setError(result.error);
        }
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        const result = await login({
            token: credentialResponse.credential,
            isGoogle: true
        });

        if (result === true) {
            navigate('/profile/mailbox', { replace: true });
        } else if (result?.redirectTo) {
            navigate(result.redirectTo, { replace: true });
        } else if (result?.error) {
            setError(result.error);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="loginFormContainer">
            <h2 className="loginFormTitle">{t('auth.login.title')}</h2>
            {error && <div className="errorMessage">{error}</div>}
            <div className="social-login">
                <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                    <GoogleLogin
                        onSuccess={handleGoogleSuccess}
                        onError={() => {
                            setError(t('auth.login.googleSignInFailed'));
                        }}
                        theme="outline"
                        size="large"
                        text="signin_with"
                    />
                </GoogleOAuthProvider>
            </div>
            <div className="loginSeperator"></div>
            <form onSubmit={handleSubmit} className="loginForm">
                <div className="loginUsernameForm">
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="loginFormInput"
                        placeholder={t('auth.login.email')}
                    />
                </div>
                <div className="loginPasswordForm">
                    <div className="passwordInputContainer">
                        <input
                            type={showPassword ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="loginFormInput"
                            placeholder={t('auth.login.password')}
                        />
                        <FontAwesomeIcon
                            icon={showPassword ? faEyeSlash : faEye}
                            onClick={togglePasswordVisibility}
                            className="passwordToggleIcon"
                        />
                    </div>
                </div>
                <Link to="/forgot-password" className="forgotButton">{t('auth.login.forgotPassword')}</Link>
                <button type="submit" className="loginFormButton">{t('auth.login.loginButton')}</button>
            </form>
            <div className="loginSeperator"></div>
            <div className="registerDescription">
                <p>{t('auth.login.noAccount')} <Link to="/register" className="register-link">{t('auth.login.registerNow')}</Link></p>
            </div>
            <div className="loginGuestNote">
                <p>{t('auth.login.guestAccountNote')}</p>
            </div>
        </div>
    );
};

export default Login;